import { useCallback, useEffect, useState } from "react";

export function useLoad<T>(fn: () => Promise<T>, deps: unknown[]): {
  data: T | null; error: string | null; loading: boolean; reload: () => void;
} {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(fn, deps);
  useEffect(() => {
    let live = true;
    setLoading(true);
    run().then(
      (d) => { if (live) { setData(d); setError(null); } },
      (e) => { if (live) setError(e instanceof Error ? e.message : String(e)); },
    ).finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [run, tick]);
  return { data, error, loading, reload: () => setTick((t) => t + 1) };
}

export function errorText(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}

export const EYE_LABEL: Record<string, string> = { OD: "Right eye", OS: "Left eye", OU: "Both eyes" };
